'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var COMPOSING = exports.COMPOSING = typeof Symbol === 'function' ? Symbol('composing') : '@@react-decorate/composing';


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-decorate/lib/constants.js
 ** module id = 718
 ** module chunks = 0
 **/